<template>
    <div class="third-login">
        <a class="login-btn" href="https://service.green-x.me/platform/login.html?appKey=greeng_6447&redirectUrl=https://www.greenx.mom">
            GreenX 授权登录
        </a>
    </div>

</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.third-login {
    padding: 20px 15px;
    .login-btn {
        background-color: #19bca0;
        color: #ffffff;
        display: block;
        text-align: center;
        padding: 10px 15px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }
}
</style>